<template>
  <div class="d-flex flex-column align-items-center justify-content-center cursor-pointer p-2" @click="customRequestEvent()" style="width: 85px; transition: transform 0.2s ease;" onmouseover="this.style.transform='scale(1.05)'" onmouseout="this.style.transform='scale(1)'">
    <div style="width: 64px; height: 64px; border-radius: 50%; padding: 2px; background: linear-gradient(135deg, #ff6ec7, #f9a826); margin-bottom: 8px; box-shadow: 0 4px 10px rgba(255, 110, 199, 0.3);">
      <img v-if="!isAvatarMissing"
           :src="imageURL"
           style="width: 100%; height: 100%; border-radius: 50%; object-fit: cover; border: 2px solid #111;" @error="imageLoadError">
      <img v-else src="@/assets/images/default_user.png"
           style="width: 100%; height: 100%; border-radius: 50%; object-fit: cover; border: 2px solid #111;">
    </div>
    <div class="text-white font-size-12 font-weight-500 text-truncate text-center w-100" style="opacity: 0.9;" :title="influencer.name || influencer.username">{{ influencer.name || influencer.username }}</div>
  </div>
</template>

<script>

import {httpMixin} from "@/mixin/http-mixin";
import {SERVICE_CONTENT} from "@/properties/micro-service";
import {isUserActive} from "@/common/comm-service";

export default {
  props: ['influencer'],
  name: "CustomRequestInfluencerAvatar",
  mixins: [httpMixin],
  data() {
    return {
      imageURL: '',
      isAvatarMissing: false
    }
  },
  created() {
    this.loadAvatarImg();
  },
  methods: {
    loadAvatarImg() {
      let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.influencer.id}/avatar`;
      this.getUnSecureData(url, (imageURL) => {
        this.imageURL = imageURL.replace('dp', 'dp_150X150');
        this.isAvatarMissing = false;
      });
    },
    imageLoadError(event) {
      this.isAvatarMissing = true;
    },
    customRequestEvent() {
      if (isUserActive(this.influencer)) {
        this.$emit('customRequest');
      }
    }
  }
}
</script>


